import { publicClient, privateClient } from './client';
import { HdDetails } from './HdDetails';

const customHdDetails = (pub: boolean) => new HdDetails(pub ? publicClient : privateClient);
export default customHdDetails;
